import {applyMiddleware, combineReducers, createStore} from "redux";
import {questionsReducer} from "../Reducers/questions";
import {listsReducer} from "../Reducers/lists";
import {programsReducer} from "../Reducers/programs";
import {activeBlocksReducer, blocksReducer, createListBlocksReducer, pickedBlocksReducer,} from "../Reducers/blocks";
import {projectsReducer} from "../Reducers/projects";
import {usersReducer} from "../Reducers/users";
import {kindsReducer} from "../Reducers/kinds";
import {typesReducer} from "../Reducers/types";
import {modesReducer} from "../Reducers/modes";
import {findingKindsReducer} from "../Reducers/findingKinds";
import {controlsReducer} from "../Reducers/controls";
import {controlListReducer} from "../Reducers/control_list";
import {controllingEntitySubjectsReducer} from "../Reducers/controllingEntitySubjects";
import thunk from "redux-thunk";
import {composeWithDevTools} from "redux-devtools-extension";
import {userDataReducer} from "../Reducers/userData";
import { publicOrdersReducer } from "../Reducers/publicOrders";
import { paymentClaimsReducer } from "../Reducers/paymentClaims";

const rootReducer = combineReducers({
  questions: questionsReducer,
  lists: listsReducer,
  programs: programsReducer,
  blocks: blocksReducer,
  createListBlocks: createListBlocksReducer,
  pickedBlocks: pickedBlocksReducer,
  activeBlocks: activeBlocksReducer,
  projects: projectsReducer,
  kinds: kindsReducer,
  types: typesReducer,
  modes: modesReducer,
  findingKinds: findingKindsReducer,
  users: usersReducer,
  controls: controlsReducer,
  controlList: controlListReducer,
  controllingEntitySubjects: controllingEntitySubjectsReducer,
  userData: userDataReducer,
  publicOrders: publicOrdersReducer,
  paymentClaims: paymentClaimsReducer,
});

export const store = createStore(
  rootReducer,
  {
    questions: { isLoading: false, isError: false, questions: [] },
    lists: { isLoading: false, isError: false, lists: [] },
    programs: { isLoading: false, isError: false, programs: [], selected: null },
    blocks: { isLoading: false, isError: false, blocks: [] },
    createListBlocks: { isLoading: false, isError: false, blocks: [] },
    pickedBlocks: { pickedBlocks: [] },
    activeBlocks: { activeBlocks: [] },
    projects: { isLoading: false, totalElements: 0, projects: [] },
    kinds: { isLoading: false, isError: false, kinds: [] },
    types: { isLoading: false, isError: false, types: [] },
    modes: { isLoading: false, isError: false, modes: [] },
    findingKinds: { isLoading: false, isError: false, findingKinds: [] },
    users: { isLoading: false, isError: false, users: [] },
    controls: { isPlannedControlsLoading: false, isActiveControlsLoading: false, isDoneControlsLoading: false, isManageDoneControlsLoading: false, isManagePlannedControlsLoading: false, isManageActiveControlsLoading: false, isLoading: false, isError: false, controls: [], plannedControls: [], activeControls: [], doneControls: [], managePlannedControls: [], manageActiveControls: [], manageDoneControls: [], tableFilters: [], tableName: '' },
    controlList: { isLoading: false, isError: false, controlList: [] },
    controllingEntitySubjects: { isLoading: false, isError: false, controllingEntitySubjects: [] },
    userData: {isLoading: false, user: {}, isLogged: false},
    publicOrders: {isLoading: false, isError: false, orders: [], count: 0},
    paymentClaims: { isLoading: false, isError: false, data: [] },
  },
  composeWithDevTools(applyMiddleware(thunk))
);

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch
